export default __webpack_public_path__ + "static/media/logo_title_white.4c64e0b1.png";